<template>
  <div>
    <b-form-radio-group
      :checked="value"
      stacked
      class="select-add-branch-method"
      @input="$emit('input', $event)"
    >
      <b-form-radio
        value="clone"
        class="w-100"
      >
        <div>{{ cloneText }}</div>
      </b-form-radio>
      <div
        v-if="value === 'clone'"
        class="select-branch-container"
      >
        <branch-select
          :label="$t('branch.select-branch')"
          :label-cols-md="6"
          label-class="font-weight-normal text-normal"
          :value="branchId"
          @input="$emit('update:branch-id', $event)"
        />
      </div>
      <b-form-radio
        value="create"
        class="mt-2"
      >
        <div>{{ createText }}</div>
      </b-form-radio>
    </b-form-radio-group>
  </div>
</template>

<script>
import { BFormRadio, BFormRadioGroup } from 'bootstrap-vue'
import BranchSelect from '@/@okmenu/components/inputs/BranchSelect'

export default {
  name: 'SelectAddBranchMethod',
  components: {
    BranchSelect, BFormRadio, BFormRadioGroup,
  },
  props: {
    value: {
      type: String,
      default: 'clone',
    },
    branchId: {
      type: [String, Number],
      default: null,
    },
    cloneText: {
      type: String,
      default: 'Take a copy from the existing branch',
    },
    createText: {
      type: String,
      default: 'Create new branch with new setup',
    },
  },
}
</script>

<style lang="scss">
.select-add-branch-method {
  .custom-control-label {
    width: 100%;
    margin-bottom: 8px;
  }

  .select-branch-container {
    margin-top: -3px;

    .form-group {
      margin-bottom: 8px;
    }
  }
}
</style>
